const localhostEndpoint = "http://localhost:8081/api/";
const ipEndpoint = "http://172.20.10.4:8080/api/";
const productionEndpoint = "https://pad.cortejusticialalibertad.com/api/";

//se cambia la base URL
const defaultEndpoint = productionEndpoint;

const restrictions = {
    MIN_DATE_TO_MAKE_ORDER: new Date()
}

export const environment = {
    baseUrl: defaultEndpoint,
    businessRules: restrictions
}
